export default class MealPlanNormalizer {

    static normalizeAll(mealplans, brand) {
        if (!mealplans || typeof mealplans !== 'object') {
            return mealplans;
        }

        const normalized = {};

        Object.keys(mealplans).forEach(code => {
            normalized[code] = this.normalizeName(mealplans[code], brand);
        });

        return normalized;
    }

    static normalizeName(planName, brand) {
        if (!planName) return planName;

        const rules =
            window.__pt?.ln?.mealPlanNormalization?.[brand];

        if (!rules || !Array.isArray(rules)) {
            return planName;
        }

        return rules.reduce((text, rule) => {
            const regex = new RegExp(`\\b${rule.from}\\b`, 'g');
            return text.replace(regex, rule.to);
        }, planName);

    }
}
